export enum WIDGET_KEYS {
  PROGRESS = 'PROGRESS',
  HEATMAP = 'HEATMAP',
  QBANK_PERFORMANCE = 'QBANK_PERFORMANCE',
  TOPIC_RADAR = 'TOPIC_RADAR',
  FLASHCARD_TREND = 'FLASHCARD_TREND',
  DAYS_UNTIL_EXAM = 'DAYS_UNTIL_EXAM',
  MY_BOOKMARKS = 'MY_BOOKMARKS',
}

export interface QBankPerformanceDataPoint {
  date: string;
  correctCount: number;
  incorrectCount: number;
  omittedCount: number;
  score: number;
}

export interface FlashcardTrendDataPoint {
  date: string;
  completedFlashcardCount: number;
}

export interface TopicRadarData {
  [topicName: string]: {
    correct: number;
    total: number;
    percentage: number;
  };
}

export interface FormattedBookmark {
  id: string;
  title: string;
  type: 'article' | 'video';
  dateAdded: string;
}
